import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
const USER_API = environment.apiUrl;

@Injectable({
    providedIn: 'root'
})
export class UserContestService {
   
    constructor(private http: HttpClient) { }

    getUserContestList(query): Observable<any> {
        return this.http.get(USER_API + "user-contest?" + query);
    }
    getUserContestLeaderBoardList(query): Observable<any> {
        const randomNumber = Math.floor(Math.random() * 50001) + 50000;// to avoid caching we are sending random number
        return this.http.get(USER_API + "user-contest/user-contest-leader-board?" + query + "&rand=" + randomNumber);
    }
    getUserContestLeaderBoardById(query): Observable<any> {
        return this.http.get(USER_API + "user-contest/user-contest-leader-board?" + query);
    }
    getUserContestListWithoutAuth(query): Observable<any> {
        return this.http.get(USER_API + "user-contest/v1?" + query);
    }

    getUserContestDetails(id): Observable<any> {
        return this.http.get(USER_API + "user-contest/" + id);
    }

    updateUserContest(id, userContestData): Observable<any> {
        return this.http.put(USER_API + 'user-contest/' + id, userContestData);
    }

    addUserContest(userContestData): Observable<any> {
        return this.http.post(USER_API + 'user-contest', userContestData);
    }

    getUserContest(id): Observable<any> {
        return this.http.get(USER_API + "user-contest/" + id);
    }
    getUserContestByQuestionId(questionId): Observable<any> {
        return this.http.get(USER_API + "user-contest/contest-details/" + questionId);
    }
    updatePoints(matchId): Observable<any> {
        return this.http.get(USER_API + "user-contest/update-points/" + matchId);
    }

    getEventStatistics(matchId){
        const randomNumber = Math.floor(Math.random() * 50001) + 50000;// to avoid caching we are sending random number
        //return this.http.get(USER_API + "statistics?" + matchId);
        return this.http.get(USER_API + "statistics?" + matchId + "&rand=" + randomNumber);
    }

}